// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__O2fdT","inner":"Footer_inner__1NpFd"};